import React from "react";
import { Select, Form } from "antd";
import { useSelector } from "react-redux";
import { $t } from "~/i18n.js";

export const MaterialSelect = ({
  value,
  onChange,
  disabled,
  required = false,
}) => {
  // Get materials from Redux flights.kisten state and filter for reservable
  const materials = useSelector(
    (state) => state.materiaal?.material?.filter((m) => m.is_reservable) || [],
  );

  const handleChange = (materialId) => {
    if (onChange) {
      onChange(materialId);
    }
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder={$t("Selecteer materiaal")}
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      options={materials.map((material) => ({
        value: material.id,
        label: material.name,
      }))}
    />
  );
};
